import {RootStateType} from '../../store';

export const selectCurrentView = (state: RootStateType) => {
    return state.navigation.actual;
};
